import { MensajeInformativoDialogComponent } from './../dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component';
import { Component, OnInit } from '@angular/core';
import { AgenteService } from '../../../services/agente/agente.service';
import { InformacionBasicaAgente } from '../../../models/agente/informacio-basica-agente.class';
import { AdapterDetalleSelect } from '../../../models/adapter/adapter-detalle-select';
import { AdapterService } from '../../../services/adapter/adapter.service';
import { CookieService } from 'ngx-cookie';
import { MenuService } from '../../../services/menu/menu.service';
import { Agente } from '../../../models/agente/agente.class';
import { NavbarService } from '../../../services/navbar/navbar.service';
import { DialogService } from '../../../services/dialog/dialog.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  informacionAgente: InformacionBasicaAgente = new InformacionBasicaAgente();
  seleccionDetalle: String = '0';
  agente: Agente;
  adapterDetalleSelect: AdapterDetalleSelect[] = [];
  mostrarListaDetalle: boolean;

  constructor(
    private agenteService: AgenteService,
    private adapterService: AdapterService,
    private cookieService: CookieService,
    private menuService: MenuService,
    private dialogService: DialogService,
    private navbarService: NavbarService
  ) {
    this.mostrarListaDetalle = agenteService.isPerfilAsesorOADelegado();
  }

  ngOnInit(): void {
    this.cargarAgente();
  }

  async cargarAgente() {
    this.agente = await this.agenteService.cargarInformacionAgente();
    this.agenteService.setAgente(this.agente);
    if (this.agente !== null) {
      this.informacionAgente = this.agente.informacionBasica;
      if (this.agente.isAsesor()) {
        this.adapterDetalleSelect =
          this.adapterService.construirAdapterDetalleAgente(this.agente);
        this.cargarAgenteXCookie();
      } else {
        this.menuService
          .cargarMenu(this.agenteService.getPerfil(), this.agente)
          .catch((err) => this.manejarErrorCargaMenu(err));
      }
    }
  }

  manejarErrorCargaMenu(err) {

    const msg = 'Falla al cargar el menú';

    console.error(msg + '!:', err);

    this.dialogService.open(MensajeInformativoDialogComponent, {
      mensaje: msg + '. ¿Desea recargar la página?',
      funcionAceptar: () => {
        window.location.reload();
      },
      funcionCancelar: () => {}
    });
  }

  private inicializarValorApdater() {
    if (
      this.adapterDetalleSelect !== null &&
      this.adapterDetalleSelect.length === 1
    ) {
      this.seleccionDetalle = this.adapterDetalleSelect[0].codigo;
      this.buscarInformacionAgenteXDetalle();
    }
  }

  cargarAgenteXCookie() {
    const cookieAgente = this.cookieService.get('KAgente');
    if (
      cookieAgente !== undefined &&
      cookieAgente !== null &&
      cookieAgente !== ''
    ) {
      this.seleccionDetalle = window.atob(cookieAgente.toString());
      this.buscarInformacionAgenteXDetalle();
    } else {
      this.inicializarValorApdater();
    }
  }

  buscarInformacionAgenteXDetalle() {
    this.reiniciarDetalleAsesor();
    if (this.seleccionDetalle !== '0') {
      const resultado =
        this.agenteService.cargarInformacionComplementariaAgente(
          this.seleccionDetalle
        );
      resultado.then((data) => {
        this.agente = this.agenteService.getAgente();
        this.menuService
          .cargarMenu(this.agenteService.getPerfil(), this.agente)
          .catch((err) => this.manejarErrorCargaMenu(err));
        this.navbarService.setDetalle(this.seleccionDetalle);
      });
    }
  }

  reiniciarDetalleAsesor() {
    this.agente = this.agenteService.getAgente();
    if (this.agente !== null && this.seleccionDetalle === '0') {
      this.agente.informacionComplementaria = null;
      this.agenteService.setAgente(this.agente);
      this.agenteService.removeKAgente();
    }
  }

  deshabilitarDetalle() {
    let deshabilitado = false;
    if (!window.location.href.toUpperCase().includes('INICIO') &&
      !window.location.href.includes('mis-negocios') &&
      !window.location.href.includes('mis-clientes')) {
      deshabilitado = true;
    }

    return deshabilitado;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/navbar/navbar.component.ts